import { ref } from 'vue';

export function useUndoRedo(maxSteps = 20) {
  const history = ref<unknown[]>([]);
  const future = ref<unknown[]>([]);

  function cloneState(state: unknown) {
    return JSON.parse(JSON.stringify(state));
  }

  function commit(current: unknown) {
    history.value.push(cloneState(current));
    if (history.value.length > maxSteps) {
      history.value.shift();
    }
    future.value = [];
  }

  function undo(current: unknown, apply: (state: unknown) => void) {
    if (history.value.length === 0) return;
    const last = history.value.pop();
    future.value.unshift(cloneState(current));
    apply(last);
  }

  function redo(current: unknown, apply: (state: unknown) => void) {
    if (future.value.length === 0) return;
    const next = future.value.shift();
    history.value.push(cloneState(current));
    apply(next);
  }

  function clear() {
    history.value = [];
    future.value = [];
  }

  return {
    commit,
    undo,
    redo,
    clear,
    canUndo: () => history.value.length > 0,
    canRedo: () => future.value.length > 0,
  };
}
